// Copyright (c) 2022 by Move Closer

import { Component, Vue } from 'vue-property-decorator'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Component<AbstractModule>({ name: 'AbstractModule' })
export class AbstractModule extends Vue {
  // Here you can add global module shared logic.
  //
}
